import { render, staticRenderFns } from "./languageDropdown.vue?vue&type=template&id=447417c6&scoped=true"
import script from "./languageDropdown.vue?vue&type=script&lang=js"
export * from "./languageDropdown.vue?vue&type=script&lang=js"
import style0 from "./languageDropdown.vue?vue&type=style&index=0&id=447417c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447417c6",
  null
  
)

export default component.exports